import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class DocusignService {
  private http: HttpClient = inject(HttpClient);

  createEnvelope(
    fileName: string,
    fileData: string,
    userFullName: string,
    email: string,
    clientID: string
  ): Observable<CreateEnvelopeRes> {
    const subject: string = `${userFullName} - ${fileName}`;

    const recipient = {
      fullName: userFullName,
      email: email,
      clientUserId: clientID,
      signHereTabs: [
        {
          anchorString: 'SIGN_HERE'
        }
      ]
    };
    const recipients = [recipient];

    const document = {
      originalFileName: fileName,
      contentBase64: fileData
    };
    const documents = [document];

    return this.http.post<CreateEnvelopeRes>(`${environment.docuSignApiUrl}`, {
      subject,
      recipients,
      documents
    });
  }

  generateSigningUrl(envelopeId: string, recipientId: string, returnUrl: string): Observable<GenerateSigningUrlRes> {
    return this.http.post<GenerateSigningUrlRes>(
      `${environment.docuSignApiUrl}/${envelopeId}/recipients/${recipientId}/embedded/url`,
      {
        returnUrl
      }
    );
  }

  getSignedDocument(envelopeId: string) {
    return this.http.get(`${environment.docuSignApiUrl}/${envelopeId}/documents/signed`, {
      responseType: 'blob'
    });
  }
}

export interface CreateEnvelopeRes {
  docuSignEnvelopeID: string;
  providerEnvelopeID: string;
  subject: string;
  status: string;
  recipients: RecipientDto[];
}

export interface RecipientDto {
  localRecipientID: string;
}

export interface GenerateSigningUrlRes {
  url?: string;
}
